import { Icon, Text } from '@zillow/constellation-10';
import { IconArchiveFilled, IconSpamFolderFilled } from '@zillow/constellation-icons';
import { MESSAGE_LOAD_ERROR_TEXT } from '../../constants';
import type { ConversationItemProps } from './index';

type MessageContentProps = Pick<
  ConversationItemProps,
  'isPhoneLead' | 'isMessageOwner' | 'latestMessage' | 'isArchived' | 'isSpamOrReported' | 'isUnread'
>;

export default function MessageContent({
  isPhoneLead,
  isMessageOwner,
  latestMessage,
  isArchived,
  isSpamOrReported,
  isUnread,
}: MessageContentProps) {
  if (!latestMessage && !isPhoneLead) {
    return <Text textStyle="body-sm">({MESSAGE_LOAD_ERROR_TEXT})</Text>;
  }

  return (
    <Text textStyle="body-sm" css={{ color: isUnread ? 'text.neutral' : 'text.subtle', truncate: 'end' }}>
      {isArchived && <Icon render={<IconArchiveFilled />} size="sm" css={{ marginRight: 'tighter' }} />}
      {isSpamOrReported && <Icon render={<IconSpamFolderFilled />} size="sm" css={{ marginRight: 'tighter' }} />}
      {isPhoneLead ? '(Phone lead)' : `${isMessageOwner ? 'You: ' : ''}${latestMessage}`}
    </Text>
  );
}
